export const primaryNav = [
  { label: "Problems We Solve", to: "/problems/" },
  { label: "How It Works", to: "/solutions/" },
  { label: "Insights", to: "/insight/" },
  { label: "Course Catalog", to: "/course-catalog/" },
  { label: "Pricing", to: "/purchase/" },
] as const;

/** Industry pages: slug only. Links are built as /who-we-help/$slug. */
export const industryNav = [
  { label: "Small and Midsize Businesses", slug: "small-midsize-businesses" },
  { label: "Mining and Natural Resources", slug: "mining-natural-resources" },
  { label: "Manufacturing", slug: "manufacturing" },
  { label: "Supply Chain and Logistics", slug: "supply-chain-logistics" },
  { label: "Utilities and Energy", slug: "utilities-energy" },
  { label: "Construction and Engineering", slug: "construction-engineering" },
  { label: "Healthcare", slug: "healthcare" },
  { label: "Professional and Business Services", slug: "professional-business-services" },
  { label: "Government and Public Sector", slug: "government-public-sector" },
] as const;

/** Problem pages: slug only. Links are built as /problems/$slug. */
export const problemNav = [
  { label: "Preparing New Supervisors", slug: "preparing-new-supervisors" },
  { label: "Building Accountability", slug: "building-accountability" },
  { label: "Improving Difficult Conversations", slug: "improving-difficult-conversations" },
  { label: "Creating Consistent Leadership", slug: "creating-consistent-leadership" },
  { label: "Leading Through Change", slug: "leading-through-change" },
  { label: "Scaling with a Lean HR Team", slug: "scaling-leadership-development-lean-hr" },
] as const;

export const footerGroups = [
  { heading: "Problems We Solve", kind: "problem", items: problemNav },
  {
    heading: "Explore",
    kind: "static",
    items: [
      { label: "How It Works", to: "/solutions/" },
      { label: "Courses", to: "/course-catalog/" },
      { label: "View Entire Schedule", to: "/schedule/" },
      { label: "Pricing", to: "/purchase/" },

      { label: "Leadership Gaps Assessment", to: "/leadership-gaps-assessment/" },
      { label: "Insights", to: "/insight/" },
      { label: "Blog", to: "/blog/" },
    ],
  },
  {
    heading: "Company",
    kind: "static",
    items: [
      { label: "About Leadership Edge Live", to: "/about-us/" },
      { label: "FAQ", to: "/faq/" },
      { label: "Contact", to: "/contact/" },
    ],
  },
] as const;
